/**
 * Shared types for repository selection components.
 */

export type UploadStatus = 'pending' | 'uploading' | 'completed' | 'error'

export interface UploadedRepo {
  id: number
  name: string
  size: string
  originalFilename: string
  tarFile?: File
  s3Path?: string

  // Status tracking — `'pending'` is set by the chatbox manual-upload flow
  // (modal stores the tarball, chat send time uploads to S3); `'completed'`
  // is set by the IDE-workspace tab once the project tarball lands in S3.
  uploadStatus?: UploadStatus

  // Origin metadata for the IDE-workspace upload tab. Lets consumers
  // distinguish a directory picked from the OS file dialog from a project
  // imported via the IDE plugin bridge.
  uploadType?: 'file' | 'directory'
  source?: 'ide' | 'external'
  ideProjectPath?: string
}

export interface WebkitDirectoryHTMLInputElement extends HTMLInputElement {
  webkitdirectory: boolean
}

/**
 * Formats bytes to human-readable file size.
 */
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i]
}
